import React from "react";
import styles from "./TableHeadSortIcon.module.scss";

import SortIconAsc from "../../../assets/img/sortIconAsc.png";

export interface ITableHeadSortIconProps {
  direction?: string;
}

export const TableHeadSortIcon: React.FC<ITableHeadSortIconProps> = ({
  direction = "",
}) => {
  const className = styles[`sort-icon--${direction}`];
  return (
    <img src={SortIconAsc} alt="sort" className={`${styles["sort-icon"]} ${className}`}/>
  );
};
